import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import { useLocation } from "react-router-dom";
import {
  Toolbar,
  Box,
  Typography,
  TextField,
  Hidden,
  ClickAwayListener,
  Button,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import AdjustIcon from "@material-ui/icons/Adjust";
import Grid from "@material-ui/core/Grid";
import MenuListComposition from "../TopPart/MenuListComposition";
import fire from "../../Pages/LoginPage/fire";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import InputInfor from "../../Components/InputInfor/InputInfor";
import { useSelector } from "react-redux";
import { DatePicker } from "@material-ui/pickers";

export default function ScrollDownWebAppBar(props) {
  const homeLink = "/";
  const placeLink = "/place";
  const expLink = "/experience";
  const logInLink = "/login";
  const onlExpLink = "/onlExperience";
  const location = useLocation();
  const pathName = location.pathname;

  const [place, setPlace] = useState(false);
  const [exp, setExp] = useState(false);
  const [onlExp, setOnlExp] = useState(false);
  useEffect(() => {
    authListener();
  }, []);
  useEffect(() => {
    if (pathName === placeLink) {
      setPlace(true);
    } else if (pathName === expLink) {
      setExp(true);
      setOnlExp(false);
    } else if (pathName === onlExpLink) {
      setOnlExp(true);
      setExp(false);
    }
  });
  var oppositeScrollDownAppBar;
  if (props.scrollDownAppBar) {
    oppositeScrollDownAppBar = false;
  } else {
    oppositeScrollDownAppBar = true;
  }
  let history = useHistory();
  const [inputClick, setInputClick] = useState(oppositeScrollDownAppBar);
  const [addPadding, setAddPadding] = useState(false);

  const useStyles = makeStyles((theme) => ({
    root: {},
    AppBar: {},
    logo: {
      fontSize: 40,
      fontWeight: "bold",
      textDecoration: "none",
      paddingTop: 10,
      display: "inline",
    },
    logo2: {
      [theme.breakpoints.down("xs")]: { paddingTop: 10 },

      fontSize: "23px",
    },
    linkAppBar: {
      color: `${props.color}`,
      [theme.breakpoints.down("xs")]: { paddingTop: 10 },
      borderColor: props.borderColor,
      fontSize: 16,
      textDecoration: "none",
      alignItems: "center",
      transition: "all ease 0.5s",
      borderBottom: "1px solid transparent",
      "&:hover": {
        borderColor: props.color,
      },
    },
    onlExplinkAppBar: {
      [theme.breakpoints.down("xs")]: { paddingTop: 10, display: "none" },
      color: `${props.color}`,
      borderColor: props.borderColor,
      fontSize: 16,
      textDecoration: "none",
      alignItems: "center",
      transition: "all ease 0.5s",
      borderBottom: "1px solid transparent",
      "&:hover": {
        borderColor: props.color,
      },
    },
    AppBar: {
      position: "static",
      background: "transparent",
      boxShadow: "none",
    },
    Input: {
      borderRadius: 50,
      "&:hover": { boxShadow: "0px 5px 20px 0px #000000c2" },
      padding: "1% 1% 1% 5%",
      margin: "10px 0 10px 0",
      border: "1px solid #bbbbbb ",
    },
    searchIcon: {
      borderRadius: 50,
      color: "white",
      backgroundColor: "#f56a79",
    },
    menuButton: {
      padding: 0,
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },

    bigLogo: {
      justifyContent: "center",
      [theme.breakpoints.up("md")]: {
        justifyContent: "flex-start",
      },
      [theme.breakpoints.down("sm")]: { display: "none" },
    },
    Grid2: {
      justifyContent: "center",
      [theme.breakpoints.up("md")]: {
        justifyContent: "flex-end",
      },
      [theme.breakpoints.down("sm")]: {
        padding: "15px 0 0 0 ",
      },
      [theme.breakpoints.down("xs")]: {
        padding: 0,
      },
    },
    typo: {
      justifyContent: "center",
    },
    inputInfor: {
      marginTop: 13,
      [theme.breakpoints.down("sm")]: {
        marginTop: 15,
      },
      padding: "0 0 15px 0",
    },
  }));
  const [user, setUser] = useState("");

  function authListener() {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser("");
      }
    });
  }

  const classes = useStyles();

  var name, email, photoUrl, uid, emailVerified, userName;
  function toHomePage() {
    history.push("/");
  }
  if (user != null) {
    name = "alooo";
    email = user.email;
    userName = name.substring(0, name.indexOf("@"));
    photoUrl = user.photoURL;
    emailVerified = user.emailVerified;
    uid = user.uid;
  }

  function handleLogout() {
    fire.auth().signOut();
  }

  var h = window.innerHeight;
  const chosenPlace = useSelector((state) => state.roomData.chosenPlace);
  const checkDate = useSelector((state) => state.checkDate);

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (props.scrollDownAppBar) {
          setInputClick(false);
        }
      }}
    >
      <div className={classes.root} style={props.pageStyle}>
        <Grid container alignItems="center" justify="center">
          <Grid
            item
            alignItems="center"
            className={classes.bigLogo}
            container
            sm={12}
            md={4}
            onClick={toHomePage}
          >
            <AdjustIcon className={classes.logo} style={props.logoColor} />
            <Typography className={classes.logo} style={props.logoColor}>
              HANNI
            </Typography>
          </Grid>

          {inputClick ? (
            <Grid container className={classes.Grid2} item xs={12} md={4}>
              <Hidden mdUp>
                <Grid justify="center" item xs={4} onClick={toHomePage}>
                  <Typography className={classes.logo2} style={props.logoColor}>
                    Hanni
                  </Typography>
                </Grid>
              </Hidden>
              <Grid
                justify="center"
                alignItems="center"
                container
                item
                xs={4}
                sm={1}
                md={2}
              >
                <Link
                  to={placeLink}
                  className={classes.linkAppBar}
                  style={{
                    borderBottom: place && `1px solid ${props.color}`,
                  }}
                >
                  Nơi ở
                </Link>
              </Grid>
              <Grid
                justify="center"
                alignItems="center"
                container
                xs={4}
                sm={4}
                item
                md={4}
              >
                <Link
                  to={expLink}
                  className={classes.linkAppBar}
                  style={{
                    borderBottom: exp && `1px solid ${props.color}`,
                  }}
                >
                  Trải nghiệm
                </Link>
              </Grid>
              <Grid
                justify="center"
                alignItems="center"
                container
                item
                sm={3}
                md={6}
              >
                <Link to={onlExpLink} className={classes.onlExplinkAppBar}>
                  Trải nghiệm Online
                </Link>
              </Grid>
            </Grid>
          ) : (
            <Grid
              onClick={() => {
                setInputClick(true);
              }}
              container
              item
              xs={12}
              md={4}
            >
              <Grid
                xs={12}
                onClick={props.showInput}
                container
                item
                className={classes.Input}
                style={{ paddingTop: "10px" }}
              >
                <Grid item xs={6}>
                  <TextField
                    InputProps={{ disableUnderline: true }}
                    value={chosenPlace.cityName}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item container xs={3} alignItems="center">
                  <Grid item xs={1}>
                    <div
                      style={{
                        borderLeft: "1px solid #c4b6b6",
                        height: "30px",
                      }}
                    />
                  </Grid>
                  <Grid item xs={11}>
                    <DatePicker
                      value={checkDate.checkInDate}
                      InputProps={{ disableUnderline: true }}
                      format="dd MMM"
                    />
                  </Grid>
                </Grid>
                <Grid item container xs={3} alignItems="center">
                  <Grid item xs={1}>
                    <div
                      style={{
                        borderLeft: "1px solid #c4b6b6",
                        height: "30px",
                      }}
                    />
                  </Grid>
                  <Grid item xs={11}>
                    <DatePicker
                      value={checkDate.checkOutDate}
                      InputProps={{ disableUnderline: true }}
                      format="dd MMM"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Hidden smDown>
            <Grid container item sm={12} md={4}>
              <Grid xs={8} container justify="center" alignItems="center">
                <Link to="/" item className={classes.linkAppBar}>
                  Trở thành chủ nhà
                </Link>
              </Grid>

              {user ? (
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  item
                  xs={4}
                >
                  <Typography
                    className={classes.typo}
                    style={{ color: props.color }}
                  >
                    Hi, {email.substring(0, email.indexOf("@"))} !
                  </Typography>
                  <Button
                    variant="contained"
                    color="default"
                    size="small"
                    onClick={handleLogout}
                    style={{ fontSize: 12, marginLeft: "10px" }}
                  >
                    Logout
                  </Button>
                </Grid>
              ) : (
                <Grid xs={3} container justify="center" alignItems="center">
                  <Link className={classes.linkAppBar} to={logInLink}>
                    <Button size="small" variant="contained" color="default">
                      Log in
                    </Button>
                  </Link>
                </Grid>
              )}
            </Grid>
          </Hidden>
        </Grid>

        {inputClick ? (
          <div className={classes.inputInfor}>
            <InputInfor
              setAddPadding={() => {
                setAddPadding(true);
              }}
              panTo={props.panTo}
            />
          </div>
        ) : null}
      </div>
    </ClickAwayListener>
  );
}
